"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCatalogActivityProgress = exports.getCatalogProgress = exports.getCatalogProgressState = exports.hasActiveUploadTickets = void 0;
const catalog_models_1 = require("./catalog.models");
const constants_1 = require("../ticket/hooks/constants");
const UPLOAD_ONLY_TICKET_TITLES = [
    constants_1.TicketType.CatalogImport,
    constants_1.TicketType.Categorize,
    constants_1.TicketType.Cluster,
    constants_1.TicketType.CatalogExport,
    constants_1.TicketType.Migrate,
].map((ticketType) => constants_1.ticketTypeToContentMap[ticketType].title);
const hasActiveUploadTickets = (ticketTitles) => (ticketTitles.some((ticketTitle) => UPLOAD_ONLY_TICKET_TITLES.includes(ticketTitle)));
exports.hasActiveUploadTickets = hasActiveUploadTickets;
const getCatalogProgressState = ({ openCount, pendingCount, closedCount, pendingTicketTitles, }) => {
    if (openCount && !pendingCount) {
        return catalog_models_1.CatalogProgressState.Waiting;
    }
    if (!openCount && !pendingCount && closedCount > 0) {
        return catalog_models_1.CatalogProgressState.Completed;
    }
    if (pendingTicketTitles.includes(constants_1.ticketTypeToContentMap[constants_1.TicketType.CatalogImport].title)) {
        return catalog_models_1.CatalogProgressState.Importing;
    }
    if ([
        constants_1.TicketType.Categorize,
        constants_1.TicketType.Extract,
        constants_1.TicketType.Cluster,
    ].some((ticketType) => pendingTicketTitles.includes(constants_1.ticketTypeToContentMap[ticketType].title))) {
        return catalog_models_1.CatalogProgressState.InitialProductsEnrichment;
    }
    if (pendingTicketTitles.includes(constants_1.ticketTypeToContentMap[constants_1.TicketType.CatalogExport].title)) {
        return catalog_models_1.CatalogProgressState.Exporting;
    }
    return catalog_models_1.CatalogProgressState.Waiting;
};
exports.getCatalogProgressState = getCatalogProgressState;
const getCatalogProgress = ({ openCount, pendingCount, closedCount, }) => {
    const totalCount = openCount + pendingCount + closedCount;
    return totalCount ? (closedCount + (pendingCount / 2)) / totalCount : 0;
};
exports.getCatalogProgress = getCatalogProgress;
const getCatalogActivityProgress = (workflowProgress, activeTicketTitles) => {
    const isMigrationInProgress = activeTicketTitles.includes(constants_1.ticketTypeToContentMap[constants_1.TicketType.Migrate].title);
    return {
        isUploadInProgress: (0, exports.hasActiveUploadTickets)(activeTicketTitles),
        catalogProgressState: isMigrationInProgress
            ? catalog_models_1.CatalogProgressState.Migrating
            : (0, exports.getCatalogProgressState)(workflowProgress),
        catalogProgress: (0, exports.getCatalogProgress)(workflowProgress),
    };
};
exports.getCatalogActivityProgress = getCatalogActivityProgress;
